<template>
  <Modal :show="showModal" hide-buttons size="md" @close="showModal = false">
    <BoxedSvgIcon icon="ReleaseNotes" class="-mt-16 mb-2" />
    <div class="text-center text-lg font-semibold">
      {{ $t('ui.system.release_notes.added_new_features') }}
    </div>
    <hr class="my-4 -mx-5" />
    <div v-for="versionNotes in notes" :key="versionNotes.version" class="mb-8">
      <VersionReleaseNotes :version-notes="versionNotes" />
    </div>

    <div class="flex justify-end">
      <Button @click="showModal = false">
        {{ $t('ui.common.ok_thanks') }}
      </Button>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Button from '@/components/controls/Button'
import Modal from '@/components/misc/Modal'
import { BoxedSvgIcon } from '@/components/misc/SvgIcon'
import VersionReleaseNotes from './VersionReleaseNotes.vue'
import { useReleaseNotesNotification } from '../composables/release_notes_notification'

const { notes } = useReleaseNotesNotification()

const showModal = ref(true)
</script>
